const ATTACHMENT_URL = /\/api\/v1\/customer-view\/attachments\/(\d+)/g;

/**
 * IDs von Anhängen, die bereits INLINE referenziert sind — ihre Proxy-URL
 * (`/api/v1/customer-view/attachments/<id>`) kommt in einem der übergebenen
 * HTML-Blöcke vor (Beschreibung, Kommentare). Diese Anhänge erscheinen im
 * Bereich „Dateien" nicht zusätzlich als Download-Link, sonst taucht
 * dasselbe Bild doppelt auf; alle anderen (nicht referenzierte Bilder, SVG,
 * sonstige Dateien) bleiben dort sichtbar.
 */
export function referencedAttachmentIds(html: string[]): Set<string> {
  const ids = new Set<string>();
  for (const block of html) {
    for (const match of block.matchAll(ATTACHMENT_URL)) {
      const id = match[1];
      if (id) ids.add(id);
    }
  }
  return ids;
}

/**
 * Die Proxy-Adresse eines Anhangs. Bewusst hier neben `referencedAttachmentIds`
 * — dieselbe Zeichenkette, aus der jene Funktion die Ids wieder herausliest;
 * zwei Fassungen davon liefen irgendwann auseinander.
 */
export function attachmentUrl(id: string): string {
  return `/api/v1/customer-view/attachments/${encodeURIComponent(id)}`;
}
